import { render } from "./natureza-editar.vue?vue&type=template&id=392b1c3a"
import script from "./natureza-editar.vue?vue&type=script&lang=js"
export * from "./natureza-editar.vue?vue&type=script&lang=js"

import exportComponent from "/home/econopro-ubuntu/Documents/econopro/fonts/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__